import { AfterViewInit, Directive, ElementRef, OnDestroy, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Directive({
  selector: '[b4aTinymce]'
})
export class TinymceDirective implements OnInit, OnDestroy {
  @Output() onEditorKeyup = new EventEmitter<any>();
  @Input() model: String;
  editor;

  constructor(private element: ElementRef) { }

  ngOnInit() {

      tinymce.init({
        selector: '#' + this.element.nativeElement.id,
        skin_url: '/assets/tinymce/skins/lightgray',
        paste_as_text: true,
        setup: editor => {
          this.editor = editor;
          this.editor.on('init', () => {
          this.editor.setContent(this.model)
          });
            this.editor.on('keyup', () => {
            const content = editor.getContent();
            this.onEditorKeyup.emit(content);
          });
          this.editor.on('change', () => {
            const content = editor.getContent();
            this.onEditorKeyup.emit(content);
          });
        },
        statusbar: false,
        menubar: false
      });

  }



  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/tinymce/tinymce.directive.ts